import { queryClient } from "@/queryClient"

export type BulkUnpairTerminalsParams = {
  serialNumbers: string[]
  confirmed?: boolean
}

export type BulkUnpairTerminalsResponse = {
  terminals: {
    serialNumber: string
    clientName: string | null
    clientMid: string | null
  }[]
  missingSerials: string[]
}

export const bulkUnpairTerminals = async (
  params: BulkUnpairTerminalsParams
) => {
  const { body } =
    await api.post<BulkUnpairTerminalsResponse>(
      "/terminals/bulk-unpair/",
      { body: params }
    )

  queryClient.invalidateQueries({
    queryKey: [TERMINALS_QUERY_KEY],
  })

  return body
}
